import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardFooter from '../components/DashboardFooter';

const IMG_BASE = '/images/Feb18ServerSideRefactorImages/HotScams';

const CryptocurrencyLearnMorePage = () => {
  const navigate = useNavigate();

  const digitalScamLinks = [
    { label: 'Phishing \\ Smishing \\ Spoofing', path: '/dashboard/phishing-learn-more' },
    { label: 'Tech Support', path: '/dashboard/tech-support-learn-more' },
    { label: 'Lottery, sweepstake', path: '/dashboard/lottery-sweepstake-learn-more' },
    { label: 'Law enforcement Impersonation', path: '/dashboard/law-enforcement-impersonation-learn-more' },
    { label: 'Government Impersonation', path: '/dashboard/government-impersonation-learn-more' },
    { label: 'Funeral', path: '/dashboard/funeral-learn-more' },
    { label: 'Work From Home', path: '/dashboard/work-from-home-learn-more' },
    { label: 'Grandparent', path: '/dashboard/grandparent-learn-more' },
    { label: 'Crypto ATM', path: '/dashboard/crypto-atm-learn-more' },
  ];

  const trustBasedScamLinks = [
    { label: 'Pig Butcher ( Crypto )', path: '/dashboard/cryptocurrency-learn-more' },
    { label: 'Catfishing ( Romance )', path: '/dashboard/catfishing-learn-more' },
  ];

  const psaVideos = [
    'Abused in Salt Lake City',
    'No good deed ( Charity)',
    '$700,000\u2013 Price of Love',
    'Can happen to me',
    'Scam Red Flags',
    'Scam Red Flags',
    'Grandparent',
    'Grandparent',
    'Tech Support',
    'Phantom Hacker',
  ];

  const darkPsychLinks = [
    { num: '01.', label: 'Pig Butchering Assessment', path: '/dashboard/pig-butchering-crypto' },
    { num: '02.', label: 'Catfishing Assessment', path: '/dashboard/catfishing-romance' },
    { num: '03.', label: 'Day After', path: '/dashboard/the-day-after' },
  ];

  return (
    <div className="h-full overflow-y-auto bg-white flex flex-col items-center">
      <div className="w-full max-w-[1920px]">

        {/* 1. Hero — Red title card + Image */}
        <div className="px-12 pt-8 pb-6">
          <div className="flex gap-0" style={{ height: '256px' }}>
            <div className="bg-red-600 flex flex-col justify-center px-10" style={{ width: '33%' }}>
              <h1 className="text-3xl font-extrabold text-white leading-tight">
                Pig Butchering &ndash;<br />Cryptocurrency
              </h1>
              <div className="mt-4 text-white text-sm font-bold">
                <p>. 194,407 victims</p>
                <p>. $70 Million stolen</p>
              </div>
            </div>
            <img
              src={`${IMG_BASE}/HotScamsPigButchering.jpeg`}
              alt="Pig Butchering"
              className="h-full object-cover"
              style={{ width: '67%' }}
            />
          </div>
        </div>

        {/* 2. What you need to know */}
        <div className="px-12 pb-8">
          <h2 className="text-2xl font-extrabold text-black mb-4">What you need to know</h2>
          <p className="text-black text-sm leading-relaxed mb-4">
            Everyone want to strike it rich &ndash; distant rich relative just passed, or you&rsquo;ve been selected Your cell phone rings. This is officer Kelley with the county Sheriff&rsquo;s office or this agent Steal with the FBI and I&rsquo;m calling you about outstanding warrant. During an.
          </p>
          <p className="text-black text-sm leading-relaxed">
            Everyone want to strike it rich &ndash; distant rich relative just passed, or you&rsquo;ve been selected Your cell phone rings. This is officer Kelley with the county Sheriff&rsquo;s office or this agent Steal with the FBI and I&rsquo;m calling you about outstanding warrant. During an.
          </p>
        </div>

        {/* 3. Scammer Awareness Tips — Yellow banner */}
        <div className="px-12 pb-8">
          <div className="relative w-full overflow-hidden" style={{ minHeight: '200px' }}>
            <img
              src={`${IMG_BASE}/HotScamsCatfishingStartAssessmentButtonBackgroundImage.jpeg`}
              alt="Scammer Awareness Tips"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="relative flex items-center h-full px-10 py-10" style={{ minHeight: '200px' }}>
              <h2 className="text-3xl font-extrabold text-black">
                Scammer &nbsp;Awareness Tips
              </h2>
            </div>
          </div>
        </div>

        {/* 4. Two-column: What you need to know / The hooks */}
        <div className="px-12 pb-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div>
              <h3 className="text-xl font-extrabold text-black mb-2">What you need to know</h3>
              <hr className="border-gray-300 mb-4" />
              <div className="space-y-2 text-black text-sm">
                <p>Unsolicited communications</p>
                <p>Intimidation, threats legal jeopardy.</p>
                <p>Dollar converted at Bitcoin ATM</p>
              </div>
            </div>
            <div>
              <h3 className="text-xl font-extrabold text-black mb-2">The hooks</h3>
              <hr className="border-gray-300 mb-4" />
              <div className="space-y-2 text-black text-sm">
                <p>Unsolicited communications</p>
                <p>Intimidation, threats legal jeopardy.</p>
                <p>Dollar converted at Bitcoin ATM</p>
              </div>
            </div>
          </div>
        </div>

        {/* 5. Prevention Tips */}
        <div className="px-12 pb-8">
          <h3 className="text-xl font-extrabold text-black mb-2">Prevention Tips</h3>
          <hr className="border-gray-300 mb-4" />
          <div className="space-y-2 text-black text-sm leading-relaxed">
            <p>- Do not respond to unsolicited text \ email \ call message.</p>
            <p>- Immediate block unknown unsolicited text \ email \ cell numbers.\</p>
            <p>- Resist the pressure to act quickly. Scammers create a sense of urgency to produce fear and lure victims into immediate action.</p>
            <p>- Never Share or send any personally identifiable information ( address, email , cell number, bank account, Medicare, SSN information).</p>
          </div>
        </div>

        {/* 6. Dark Psychological / Trust Based Assessments */}
        <div className="px-12 pb-8">
          <h2 className="text-2xl font-extrabold text-black mb-2">Dark Psychological / Trust Based &nbsp;Assessments</h2>
          <hr className="border-gray-300 mb-4" />
          <p className="text-black text-sm leading-relaxed mb-6">
            Discover how scammers use these emotional behavioral techniques and interaction patterns to lure, exploit and control their victims.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {darkPsychLinks.map((link) => (
              <button
                key={link.num}
                onClick={() => navigate(link.path)}
                className="text-left border border-gray-300 p-4 hover:bg-gray-50 transition-colors"
              >
                <p className="text-xs text-gray-500 mb-1">{link.num}</p>
                <p className="text-lg font-extrabold text-black">{link.label}</p>
              </button>
            ))}
          </div>
        </div>

        {/* 7. IC3 Video Vault + Know more */}
        <div className="px-12 pb-8">
          <div className="grid grid-cols-1 min-[1100px]:grid-cols-2 gap-12">
            {/* IC3 Video Vault */}
            <div>
              <h3 className="text-xl font-extrabold text-black mb-2">IC3 Video Vault</h3>
              <hr className="border-gray-300 mb-4" />
              <div className="grid grid-cols-2 gap-x-8 gap-y-2 text-sm">
                {psaVideos.map((title, idx) => (
                  <button
                    key={idx}
                    onClick={() => navigate('/dashboard/av-library/fbi-ic3')}
                    className="text-left text-black hover:text-blue-600 transition-colors"
                  >
                    {title}
                  </button>
                ))}
              </div>
            </div>

            {/* Know more */}
            <div>
              <h3 className="text-xl font-extrabold text-black mb-2">Know more</h3>
              <hr className="border-gray-300 mb-4" />

              <div className="grid grid-cols-2 gap-8">
                <div>
                  <h4 className="text-sm font-bold text-black mb-2">Digital scams</h4>
                  <div className="space-y-1">
                    {digitalScamLinks.map((scam, idx) => (
                      <button
                        key={idx}
                        onClick={() => navigate(scam.path)}
                        className="block text-left text-sm text-black hover:text-blue-600 transition-colors"
                      >
                        {scam.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div>
                  <h4 className="text-sm font-bold text-black mb-2">Trust Based scams</h4>
                  <div className="space-y-1">
                    {trustBasedScamLinks.map((scam, idx) => (
                      <button
                        key={idx}
                        onClick={() => navigate(scam.path)}
                        className="block text-left text-sm text-black hover:text-blue-600 transition-colors"
                      >
                        {scam.label}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 8. Additional Resources */}
        <div className="px-12 pb-10">
          <h2 className="text-2xl font-extrabold text-black mb-2">Additional resources</h2>
          <hr className="border-gray-300" />
        </div>

      </div>
      <DashboardFooter />
    </div>
  );
};

export default CryptocurrencyLearnMorePage;
